function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  border-top: 1px solid black;\n  overflow-y: scroll;\n  background: #404040;\n  flex: 1;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  background: hsla(0, 0%, 100%, 0.1);\n  border-radius: 4px;\n  font-size: 0.7em;\n  padding: 1px 4px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      flex: 0.8;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  width: 100%;\n  position: relative;\n\n  .spectacle-fullscreen-button {\n    display: none;\n  }\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: calc(50% - 1em);\n  width: 100%;\n  overflow: hidden;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 50%;\n  > :first-child {\n    margin-bottom: 0.5em;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  background: #383838;\n  width: 50%;\n  border-right: 1px solid black;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: row;\n  background-color: #282828;\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import PropTypes from 'prop-types';
import { DeckContext } from '../../hooks/use-deck';
import { SlideNextElementContext } from '../../hooks/use-slide';
import styled, { css } from 'styled-components';
import { Text } from '../typography';
import { FlexBox, Box } from '../layout';
import * as queryString from 'query-string';
import { Timer } from './timer';
import SpectacleLogo from '../logo';
import InternalButton from '../internal-button';
import { SYSTEM_FONT } from '../../utils/constants';
import 'broadcastchannel-polyfill';
var PresenterDeckContainer = styled('div')(_templateObject());
var NotesColumn = styled('div')(_templateObject2());
var PreviewColumn = styled('div')(_templateObject3());
var SlideContainer = styled('div')(_templateObject4());
var SlideWrapper = styled('div')(_templateObject5(), function (_ref) {
  var small = _ref.small;
  return small && css(_templateObject6());
});
var SlideCountLabel = styled('span')(_templateObject7());
var NotesContainer = styled('div')(_templateObject8());

var PresenterDeck = function PresenterDeck(props) {
  var _React$useContext = React.useContext(DeckContext),
      slideElementMap = _React$useContext.slideElementMap,
      _React$useContext$sta = _React$useContext.state,
      currentNotes = _React$useContext$sta.currentNotes,
      currentSlide = _React$useContext$sta.currentSlide,
      currentSlideElement = _React$useContext$sta.currentSlideElement,
      immediate = _React$useContext$sta.immediate,
      numberOfSlides = _React$useContext$sta.numberOfSlides;

  var isController = props.isController,
      isReceiver = props.isReceiver,
      startConnection = props.startConnection,
      terminateConnection = props.terminateConnection,
      children = props.children;
  var countSlideElements = React.useCallback(function (slideNumber) {
    return slideElementMap[slideNumber];
  }, [slideElementMap]);
  var onStartConnection = React.useCallback(function () {
    var urlParams = queryString.stringify({
      slide: currentSlide,
      slideElement: currentSlideElement,
      immediate: immediate || undefined
    });
    startConnection(urlParams);
  }, [currentSlide, currentSlideElement, immediate, startConnection]);
  var activeSlide = children.length > currentSlide ? children[currentSlide] : null; // Show next animation in the preview slide if there are animations left on the current slide

  var showNextElement = currentSlideElement + 1 < countSlideElements(currentSlide); // If there are no animations left on the current slide, then show the next slide in the preview

  var nextSlide = showNextElement ? activeSlide : children.length > currentSlide + 1 ? children[currentSlide + 1] : null;
  var castButton = React.useMemo(function () {
    if (isReceiver || typeof window.navigator.presentation === 'undefined') {
      return null;
    }

    if (isController) {
      return React.createElement(InternalButton, {
        "data-testid": "Close Connection",
        onClick: terminateConnection
      }, "Stop Casting");
    }

    return React.createElement(InternalButton, {
      "data-testid": "Start Connection",
      onClick: onStartConnection
    }, "Cast to Secondary Display");
  }, []);
  return React.createElement(PresenterDeckContainer, null, React.createElement(NotesColumn, null, React.createElement(FlexBox, {
    justifyContent: "space-between",
    paddingTop: 10,
    paddingX: 15
  }, React.createElement(SpectacleLogo, null), React.createElement(FlexBox, {
    width: 0.75,
    flexDirection: "column",
    alignItems: "flex-end"
  }, React.createElement(Text, {
    "data-testid": "use-browser-tab-text",
    fontSize: 15,
    fontFamily: SYSTEM_FONT,
    textAlign: "right",
    padding: "0px",
    margin: "0px 0px 10px"
  }, "Open a second browser tab at ", window.location.host, " to use as the audience deck", !!castButton && ' or use Chrome’s display cast to present on a secondary display', "."), castButton)), React.createElement(Box, {
    paddingRight: 15
  }, React.createElement(Timer, null)), React.createElement(NotesContainer, null, React.createElement(Text, {
    fontFamily: SYSTEM_FONT,
    lineHeight: "1.2",
    fontSize: "1.5vw"
  }, currentNotes))), React.createElement(PreviewColumn, null, React.createElement(SlideContainer, null, React.createElement(Text, {
    fontSize: 20,
    fontWeight: "bold",
    fontFamily: SYSTEM_FONT,
    textAlign: "center"
  }, "Current\xA0", React.createElement(SlideCountLabel, null, "Slide ", activeSlide.props.slideNum + 1, " of ", numberOfSlides)), React.createElement(SlideWrapper, null, activeSlide)), !!nextSlide && React.createElement(SlideContainer, null, React.createElement(Text, {
    fontSize: 20,
    fontFamily: SYSTEM_FONT,
    fontWeight: "bold",
    textAlign: "center"
  }, "Next\xA0", React.createElement(SlideCountLabel, null, "Slide ", nextSlide.props.slideNum + 1, " of ", numberOfSlides)), React.createElement(SlideNextElementContext.Provider, {
    value: {
      showNextElement: showNextElement
    }
  }, React.createElement(SlideWrapper, {
    small: true,
    "data-testid": "Next Slide"
  }, nextSlide)))));
};

PresenterDeck.propTypes = {
  children: PropTypes.node.isRequired,
  isController: PropTypes.bool.isRequired,
  isReceiver: PropTypes.bool.isRequired,
  startConnection: PropTypes.func.isRequired,
  terminateConnection: PropTypes.func.isRequired
};
export default PresenterDeck;